import { ref } from '@vue/composition-api'
import committeesApi from '@/services/api/committees'

export default function useCommitteesBulkMail() {
  const sendTypes = ref([])
  const recipients = ref([])
  const searchResults = ref([])
  const loading = ref(false)
  const sending = ref(false)
  const optionsLoading = ref(false)

  async function fetchOptions() {
    optionsLoading.value = true
    try {
      const res = await committeesApi.getBulkMailingOptions()
      const data = res.data.data != null ? res.data.data : {}
      sendTypes.value = data.sendTypes != null ? data.sendTypes : []
      recipients.value = data.recipients != null ? data.recipients : []
    } catch (_) { /* handled by http interceptor */ }
    optionsLoading.value = false
  }

  async function search(params) {
    loading.value = true
    try {
      const res = await committeesApi.getBulkMailingSearch(params)
      searchResults.value = res.data.data != null ? res.data.data : []
    } catch (_) {
      searchResults.value = []
    } finally {
      loading.value = false
    }
  }

  async function send(data) {
    sending.value = true
    try {
      const res = await committeesApi.sendBulkMailing(data)
      return res.data
    } catch (_) {
      return null
    } finally {
      sending.value = false
    }
  }

  return {
    sendTypes,
    recipients,
    searchResults,
    loading,
    sending,
    optionsLoading,
    fetchOptions,
    search,
    send
  }
}



// WEBPACK FOOTER //
// ./src/composables/committees/useCommitteesBulkMail.js